module.exports = __webpack_public_path__ + "img/yeekee.10bb8931.png";